// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/TracedCephAction/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Images_Content_Content_Content_Content_TracedCephAction_Content($image_serie_id: numeric!) {
  ceph_requests(
    where: {
      patient_image: { imageseries_id: { _eq: $image_serie_id } }
      status: { _eq: completed }
    }
    order_by: { created_at: desc_nulls_last }
  ) {
    id
  }
}

`